import { useHistory } from 'react-router-dom';
import { SessionExpiredDialog } from 'shared/domains/errors';
import { useValidateSession } from './useValidateSession';
export function SessionDialog() {
    useValidateSession();
    const history = useHistory();
    const handleClick = () => history.push('/auth');
    return <SessionExpiredDialog onClick={handleClick}/>;
}
